var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"honor-buy"},[_c('navbar',{ref:"navbar",attrs:{"title":"信用购领豪礼","show-home":""}}),_c('div',{staticClass:"banner"},[_c('swiper',{attrs:{"img-list":_vm.banners}})],1),_c('div',{staticClass:"level-navs"},[_c('level-navs',{ref:"levelNavs",attrs:{"nav-list":_vm.navList,"nav-height":_vm.navbarHeight}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }